export default "__VITE_ASSET__Bej33FEp__"